import React from 'react';
import { Helmet } from "react-helmet";
import { FaFingerprint, FaGlobe, FaShieldAlt, FaLightbulb, FaSignature } from 'react-icons/fa';
import "./OnlineBranding.css";

const OnlineBranding = () => {
  return (
    <main className="service-page">
      
      {/* ✅ SEO META */}
      <Helmet>
        <title>Online Branding Services | Skyline Bussiness Solutions</title>

        <meta 
          name="description" 
          content="Build a powerful digital identity with Skyline Business Solutions. We specialize in branding, social identity, and online reputation management." 
        />

        {/* ✅ Canonical URL */}
        <link 
          rel="canonical" 
          href="https://skylinebussinesssolutions.com/online-branding" 
        />
      </Helmet>

      {/* HERO */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">BRAND ARCHITECTURE</span>

          <h1 className="service-display">
            Digital <br />
            <span className="accent-text">Identity Systems</span>
          </h1>

          <p className="service-intro">
            At <strong>Skyline Bussiness Solutions</strong>, we build powerful and 
            consistent brand identities that turn first impressions into long-term trust and growth.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* BRAND PILLARS */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaFingerprint /></div>
            <h3>Unique Positioning</h3>
            <p>Define your brand’s identity and stand out in your industry.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaSignature /></div>
            <h3>Visual Identity</h3>
            <p>Logos, typography, and design systems for consistent branding.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaGlobe /></div>
            <h3>Omnichannel Presence</h3>
            <p>Maintain a unified brand voice across all digital platforms.</p>
          </div>
        </section>

        {/* SERVICES */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaLightbulb className="card-icon" />
            <h3>Brand Strategy</h3>
            <p>Long-term branding roadmap aligned with your business goals.</p>
          </div>

          <div className="glass-card">
            <FaFingerprint className="card-icon" />
            <h3>Social Branding</h3>
            <p>Consistent and premium visuals across social media platforms.</p>
          </div>

          <div className="glass-card">
            <FaShieldAlt className="card-icon" />
            <h3>Reputation Management</h3>
            <p>Monitor and improve your brand image across the web.</p>
          </div>
        </section>

        {/* WORKFLOW */}
        <section className="workflow-section">
          <div className="section-header">
            <h2>Our Branding Process</h2>
            <div className="line"></div>
          </div>

          <div className="workflow-steps">
            <div className="step">
              <span>01</span>
              <h4>Research</h4>
              <p>Analyze your market, competitors, and audience.</p>
            </div>

            <div className="step">
              <span>02</span>
              <h4>Strategy</h4>
              <p>Develop your brand positioning and visual direction.</p>
            </div>

            <div className="step">
              <span>03</span>
              <h4>Execution</h4>
              <p>Implement branding across all digital touchpoints.</p>
            </div>
          </div>
        </section>
      </div>

      {/* ✅ SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Online Branding Services",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solutions",
            "url": "https://skylinebussinesssolutions.com"
          },
          "description": "Professional branding services including identity design, strategy, and reputation management."
        })}
      </script>
    </main>
  );
};

export default OnlineBranding;